var map = {
	"./gallery-wip-denix-barrel_00.jpg": 2848,
	"./gallery-wip-denix-barrel_01.jpg": 2849,
	"./gallery_00.jpg": 2850,
	"./gallery_01.jpg": 2851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2847;